import comp from "./GradeLevelsSkeleton";
export default comp;
